import { ActionTracking } from '../common-public/ActionTracking';

export class BasketAndCheckoutTracking {
    constructor(private readonly _actionTracking: ActionTracking) {}

    initialize(): void {
        window.o_util.event.delegate('.order_js_basket_or_checkout', 'click', '.or_js_baseTrackingOnClick', event => {
            const clickedElement = event.target as HTMLElement;
            const label = clickedElement.getAttribute('data-tracking-label');
            const value = clickedElement.getAttribute('data-tracking-value');

            if (label && value) {
                this._actionTracking.submitEvent(
                    {
                        name: 'click',
                        features: []
                    },
                    {
                        [label]: [value]
                    }
                );
            }
        });
    }
}
